import React from "react";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { BreadcrumbsBar } from "../../../common/components/BreadcrumbsBar";

interface OrderFormScoreHeaderProps {
    orderFormId: number;
    orderFormName: string;
}
export const OrderFormScoreHeader: React.FC<OrderFormScoreHeaderProps> = ({
    orderFormId,
    orderFormName,
}) => {
    const breadcrumbs = [
        {
            name: "Contracts",
            path: "/order/new",
        },
        {
            name: orderFormName,
            path: `/order/score/${orderFormId}`,
        },
    ];

    return (
        <>
            <BreadcrumbsBar breadcrumbs={breadcrumbs} />
            <Row>
                <Col flex={1}>
                    <span>Past contract insights - </span>
                    <Link to={`/order/${orderFormId}`}>{orderFormName}</Link>
                </Col>
            </Row>
        </>
    );
};
